(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kdg-tp-color-search"] && !Shopify.designMode) return;
  try {
    class TpColorSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.hdt-tp-colorsearch__input');
    this.emptyEl = this.querySelector('.hdt-tp-colorsearch__empty');
    this.modeButtons = Array.from(this.querySelectorAll('.hdt-tp-colorsearch__mode'));

    if (!this.picker) {
      this.hidden = true;
      return;
    }

    this.mode = this.dataset.defaultMode || 'swatch';

    this.input.addEventListener('input', () => this.filter());
    this.modeButtons.forEach((btn) => {
      btn.addEventListener('click', () => this.setMode(btn.dataset.mode));
    });

    // Al elegir una variante el tema vuelve a renderizar el selector por AJAX.
    // Si se cachean fieldset/inputs quedan huerfanos y la vista de lista se
    // pierde: por eso se resuelven en vivo y se re-aplica tras cada cambio.
    this.observer = new MutationObserver(() => this.reapply());
    this.observer.observe(this.picker, { childList: true, subtree: true });

    this.reapply();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  get picker() {
    const scope = this.closest('.shopify-section') || document;
    return scope.querySelector('hdt-variant-picker');
  }

  get fieldset() {
    const picker = this.picker;
    return picker ? picker.querySelector('.hdt-product-form__input.is-style-color') : null;
  }

  get options() {
    const fieldset = this.fieldset;
    if (!fieldset) return [];
    return Array.from(
      fieldset.querySelectorAll('.hdt-product-form__values input[type="radio"]')
    ).map((input) => ({ input, label: input.nextElementSibling }));
  }

  reapply() {
    this.applyMode();
    this.filter();
  }

  setMode(mode) {
    this.mode = mode;
    this.applyMode();
  }

  applyMode() {
    const fieldset = this.fieldset;
    if (fieldset) {
      fieldset.classList.toggle('hdt-tp-colors--list', this.mode === 'list');
    }
    this.modeButtons.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.mode === this.mode);
    });
  }

  filter() {
    if (!this.input) return;
    const query = this.input.value.trim().toLowerCase();
    const options = this.options;
    let shown = 0;

    options.forEach(({ input, label }) => {
      const match = !query || (input.value || '').toLowerCase().includes(query);
      if (match) shown += 1;
      input.hidden = !match;
      if (label) label.hidden = !match;
    });

    const noResults = query !== '' && options.length > 0 && shown === 0;
    if (this.emptyEl) {
      this.emptyEl.textContent = noResults ? this.dataset.empty : '';
      this.emptyEl.hidden = !noResults;
    }
  }
}

if (!customElements.get('tp-color-search')) {
  customElements.define('tp-color-search', TpColorSearch);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kdg-tp-order-grid"] && !Shopify.designMode) return;
  try {
    class TpOrderGrid extends HTMLElement {
  connectedCallback() {
    this.moneyFormat = this.dataset.currencyFormat || '';
    this.cells = Array.from(this.querySelectorAll('.hdt-tp-grid__qty'));
    this.unitsEl = this.querySelector('[data-grid-units]');
    this.totalEl = this.querySelector('[data-grid-total]');
    this.submitEl = this.querySelector('[data-grid-submit]');

    this.cells.forEach((cell) => {
      cell.addEventListener('input', () => this.syncCell(cell));
      cell.addEventListener('change', () => this.syncCell(cell));
    });

    this.recalculate();
  }

  syncCell(cell) {
    let qty = parseInt(cell.value, 10);
    if (!Number.isFinite(qty) || qty < 0) qty = 0;

    const idInput = cell.nextElementSibling;
    const qtyInput = idInput && idInput.nextElementSibling;
    if (!idInput || !qtyInput) return;

    // Solo se envían al carrito las celdas con cantidad: los inputs
    // deshabilitados no viajan en el FormData, así se mantiene el
    // emparejamiento items[][id] / items[][quantity].
    const active = qty > 0;
    idInput.disabled = !active;
    qtyInput.disabled = !active;
    qtyInput.value = String(qty);

    this.recalculate();
  }

  recalculate() {
    let units = 0;
    let cents = 0;

    this.cells.forEach((cell) => {
      const qty = parseInt(cell.value, 10);
      if (!Number.isFinite(qty) || qty <= 0) return;
      units += qty;
      cents += qty * Number(cell.dataset.price || 0);
    });

    this.unitsEl.textContent = String(units);
    this.totalEl.textContent = units ? this.formatMoney(cents) : '';
    this.submitEl.disabled = units === 0;
  }

  formatMoney(cents) {
    const amount = (cents / 100).toLocaleString('es-CO', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    // El formato de moneda de la tienda trae un marcador tipo llave doble.
    const placeholder = new RegExp('\\{\\{[^}]+\\}\\}');
    if (this.moneyFormat && placeholder.test(this.moneyFormat)) {
      return this.moneyFormat.replace(placeholder, amount);
    }
    return '$' + amount;
  }
}

if (!customElements.get('tp-order-grid')) {
  customElements.define('tp-order-grid', TpOrderGrid);
}

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-grid-open]');
  if (opener) {
    const dialog = opener.parentElement.querySelector('[data-grid-dialog]');
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    return;
  }

  const closer = event.target.closest('[data-grid-close]');
  if (closer) {
    const dialog = closer.closest('[data-grid-dialog]');
    if (dialog) dialog.close();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kdg-tp-processing"] && !Shopify.designMode) return;
  try {
    class TpCutoffCountdown extends HTMLElement {
  connectedCallback() {
    this.cutoff = parseInt(this.dataset.cutoff, 10) || 15;
    this.render();
    this.timer = setInterval(() => this.render(), 30000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  render() {
    const now = new Date();
    const target = new Date(now);
    target.setHours(this.cutoff, 0, 0, 0);

    if (target <= now) {
      this.textContent = this.dataset.closed || '';
      return;
    }

    const diff = Math.floor((target - now) / 60000);
    const hours = Math.floor(diff / 60);
    const minutes = diff % 60;
    const parts = [];

    if (hours > 0) parts.push(`${hours}${this.dataset.hours}`);
    parts.push(`${minutes}${this.dataset.minutes}`);

    this.textContent = `${this.dataset.prefix} ${parts.join(' ')}`;
  }
}

if (!customElements.get('tp-cutoff-countdown')) {
  customElements.define('tp-cutoff-countdown', TpCutoffCountdown);
}
  } catch(e) { console.error(e); }
})();

})();
